import * as React from "react";
import {observer} from "mobx-react";
import "../../../utils/number_extensions";
import { useGlobalStores } from "../../../hooks/use_global_stores";
import { fetchSnapshotV3 } from "../../../stores/snapshot";
import { IReactionDisposer, reaction } from "mobx";
import {Grid, useMediaQuery, useTheme } from "@mui/material";

import { MonthlyExpenses } from "./MonthlyExpenses/MonthlyExpenses";
import { MoneyLeft } from "./MonthlyExpenses/MoneyLeft";
import { fetchBudgetsProgress } from "../../../stores/budgets";
import { fetchFuturePayments } from "../../../stores/due_date";
import { ISnapshotV3 } from "../../../config/snapshot";
import { IBudgetProgress } from "../../../config/budget";
import { IDueDate } from "../../../config/due_date";
import { BudgetsProgress } from "./BudgetsProgress/BudgetsProgress";
import { FuturePayments } from "./FuturePayments/FuturePayments";
import { LoadingPlaceholders } from "./Components/LoadingPlaceholders";

const ALREADY_CACHED = Promise.resolve(-1);
const isCached = (v: any): boolean => (v === -1);

const SnapshotV4Component = () => {
    const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

    const { snapshotStore, refreshStore } = useGlobalStores();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [snapshot, setSnapshot] = React.useState<ISnapshotV3 | null>(snapshotStore.snapshotV3);
    const [budgets, setBudgets] = React.useState<IBudgetProgress[]>([]);
    const [dueDates, setDueDates] = React.useState<IDueDate[]>([]);

    const fetchData = async () => {
        setLoading(true);

        const [snapshot, budgets, dueDates] = await Promise.all([
            !!snapshotStore.snapshotV3 ? ALREADY_CACHED : fetchSnapshotV3(),
            fetchBudgetsProgress(),
            fetchFuturePayments(),
        ]);

        if (!isCached(snapshot)) {
            snapshotStore.setSnapshotV3(snapshot as any);
            setSnapshot(snapshot as any);    
        }
        setBudgets(budgets);
        setDueDates(dueDates);
        setLoading(false);
    };

    React.useEffect(() => {
        fetchData();
    }, []);

    let reloadReactionDisposer: IReactionDisposer;
    React.useEffect(() => {
        if (!reloadReactionDisposer) {
            reloadReactionDisposer = reaction(
                () => refreshStore.dashboardSnapshot,
                () => {
                    fetchData();
                }
            );
        }

        return () => {
            reloadReactionDisposer();
        }
    });

    if (loading) {
        return (
            <LoadingPlaceholders />
        );
    }

    if (!snapshot) {
        return null;
    }

    return (
        <Grid container spacing={isSmallScreen ? 1 : 3}>
            <Grid size={{ xs: 12, md: 6, xl: 4 }}>
                <MonthlyExpenses snapshot={snapshot!} />
            </Grid>
            <Grid size={{ xs: 12, md: 6, xl: 8 }}>
                <MoneyLeft snapshot={snapshot!} />
            </Grid>
            <Grid size={{ xs: 12, xl: 6 }} sx={{'& > *': {height: '100%'}}}>
                <BudgetsProgress budgets={budgets} />
            </Grid>
            <Grid size={{ xs: 12, xl: 6 }} sx={{'& > *': {height: '100%'}}}>
                <FuturePayments dueDates={dueDates} />
            </Grid>
        </Grid>
    );
};
export const SnapshotV4 = observer(SnapshotV4Component);
